export const formatTime = (timeInSeconds: number) => {
  const safe = Number.isFinite(timeInSeconds) && timeInSeconds > 0 ? timeInSeconds : 0;
  const minutes = Math.floor((safe % 3600) / 60);
  const seconds = Math.floor(safe % 60);

  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

  return `${formattedMinutes}:${formattedSeconds}`;
};
// Parse a timecode into total seconds (mm:ss, numeric string, or number)
export const parseTime = (timecode: unknown): number => {
  // Coerce to string, defaulting to '0' for nullish values
  const str = String(timecode ?? '0');
  const parts = str.split(':');
  let minutes = 0;
  let seconds = 0;
  if (parts.length >= 2) {
    minutes = parseInt(parts[0], 10) || 0;
    seconds = parseInt(parts[1], 10) || 0;
  } else {
    seconds = parseInt(parts[0], 10) || 0;
  }
  return minutes * 60 + seconds;
};
